import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { register, resetRegister } from '../../actions/auth/register';
import Swal from 'sweetalert2';
import { useTranslation, Trans } from 'react-i18next';

const lngs = {
    en: { nativeName: 'English' },
    tr: { nativeName: 'Türkçe' },
    si: { nativeName: 'Slovenski jezik' }
};

function Register(props) {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const [mounted, setMounted] = useState(false);
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [passwordAgain, setPasswordAgain] = useState("");
    const [agreementTypes, setAgreementTypes] = useState([]);
    const agreementsLocalStorage = JSON.parse(localStorage.getItem('agreements'));
    const [agreements, setAgreements] = useState(agreementsLocalStorage?.agreements);
    const [agreementChecked, setAgreementChecked] = useState({});

    // Component mount edildiğinde, her bir sözleşme için onay durumunu başlangıçta false olarak ayarla
    useEffect(() => {
        const initialCheckState = {};
        agreements?.forEach((element) => {
            initialCheckState[element.id] = false;
        });
        setAgreementChecked(initialCheckState);
    }, [agreements]);

    // Sözleşme onayını toggle etme fonksiyonu
    // Sözleşme onayını toggle etme ve tipleri güncelleme
    const toggleAgreementCheck = (id, agreementType) => {
        setAgreementChecked(prevState => {
            const newState = { ...prevState, [id]: !prevState[id] };

            // Onay durumuna göre agreementTypes state'ini güncelle
            if (newState[id]) {
                setAgreementTypes(prevTypes => [...prevTypes, agreementType]);
            } else {
                setAgreementTypes(prevTypes => prevTypes.filter(type => type !== agreementType));
            }

            return newState;
        });
    };

    function handleSubmit(e) {
        e.preventDefault();

        // Zorunlu sözleşmelerin kontrolü
        const allMandatoryAgreed = agreements.every(agreement =>
            agreement.isOptional || agreementChecked[agreement.id]
        );

        if (!allMandatoryAgreed) {
            // Tüm zorunlu sözleşmeler onaylanmadıysa kullanıcıyı bilgilendir
            Swal.fire({
                icon: 'error',
                title: 'Hata',
                text: 'Lütfen tüm zorunlu sözleşmeleri onaylayın.',
                footer: '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
            });
            return; // Form gönderimini durdur
        }

        // Onaylanan sözleşmelerin tiplerini al
        const agreedTypes = agreements
            .filter(agreement => agreementChecked[agreement.id])
            .map(agreement => agreement.agreementType);
        setAgreementTypes(agreedTypes);
        
        if (password === passwordAgain) {
            dispatch(register(email, password, agreedTypes))
        } else {
            Swal.fire({
                icon: 'warning',
                title: 'Uyarı',
                text: "Şifreler birbirleriyle uyuşmuyor lütfen kontrol ediniz.",
                footer: '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
            })
        }
    }

    useEffect(() => {
        if (mounted && props.register.done === false) {
            if (props.register.error !== false) {
                if (props.register.error?.response?.status === 400) {
                    Swal.fire({
                        icon: 'error',
                        text: props.register.error?.response?.data,
                        title: 'Hata',
                        footer: '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
                    })
                } else if (props.register.error?.response?.status === 408) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Hata',
                        text: "Sms doğrulama kodunuzun süresi doldu.",
                        footer: '<a href="https://ikincigorus.onedose.io">Sms doğrulama kodu talep et.</a>'
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Hata',
                        text: "Sistem bir hata ile karşılaştı. Lütfen daha sonra tekrar deneyiniz.",
                        footer: '<a target="_blank" href="https://www.onedose.io/">Farklı bir problem yaşıyorum?</a>'
                    })
                }
            }
        }
        if (props.register.done) {
            dispatch(resetRegister())
            navigate("/patient-register")
        }
        setMounted(true)
    }, [props.register])


    return (
        <div className="">
            <img className='img-fluid mt-10 ms-10 hidden md:block' src="https://www.onedose.io/wp-content/uploads/2020/09/onedose_black.png" width={150} alt="" />
            <main className="w-full max-w-md mx-auto p-6 flex justify-center">
                <div className="mt-0 bg-white border border-gray-200 rounded-xl shadow-sm dark:bg-gray-800 dark:border-gray-700 ">
                    <div className="p-4 sm:p-14 ">
                        <div className="text-center">
                            <h1 className="block text-2xl font-bold text-gray-800 dark:text-white">Kayıt Ol</h1>
                            <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
                                Mevcut bir hesabınız varsa
                                <Link className="text-blue-600 decoration-2 hover:underline font-medium onedose-color ms-1" to="/login">
                                    buradan giriş yapın
                                </Link>
                            </p>
                        </div>
                        <div className="mt-5">
                            <form onSubmit={handleSubmit}>
                                <div className="grid gap-y-4">

                                    <div>
                                        <div className="flex justify-between items-center">
                                            <label htmlFor="email" className="block text-sm mb-2 dark:text-white">Eposta Adresi</label>
                                        </div>
                                        <div className="relative">
                                            <input
                                                required
                                                type="email"
                                                className="py-3 px-4 block w-full border-gray-200 border rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                                                placeholder={t('Password')}
                                                onChange={(e) => { setEmail(e.target.value) }}
                                                value={email}
                                                id="email"
                                                aria-describedby="basic-addon3" />
                                            <div className="hidden absolute inset-y-0 right-0 flex items-center pointer-events-none pr-3">
                                                <svg className="h-5 w-5 text-red-500" width={16} height={16} fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="flex justify-between items-center">
                                            <label htmlFor="password" className="block text-sm mb-2 dark:text-white">Şifre</label>
                                        </div>
                                        <div className="relative">
                                            <input
                                                required
                                                type="password"
                                                className="py-3 px-4 block w-full border-gray-200 border rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                                                placeholder={t('Password')}
                                                onChange={(e) => { setPassword(e.target.value) }}
                                                value={password}
                                                id="password"
                                                aria-describedby="basic-addon3" />
                                            <div className="hidden absolute inset-y-0 right-0 flex items-center pointer-events-none pr-3">
                                                <svg className="h-5 w-5 text-red-500" width={16} height={16} fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="flex justify-between items-center">
                                            <label htmlFor="password" className="block text-sm mb-2 dark:text-white">Şifre Tekrar</label>
                                        </div>
                                        <div className="relative">
                                            <input
                                                required
                                                type="password"
                                                className="py-3 px-4 block w-full border-gray-200 border rounded-md text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                                                placeholder={t('Password')}
                                                onChange={(e) => { setPasswordAgain(e.target.value) }}
                                                value={passwordAgain}
                                                id="password"
                                                aria-describedby="basic-addon3" />
                                            <div className="hidden absolute inset-y-0 right-0 flex items-center pointer-events-none pr-3">
                                                <svg className="h-5 w-5 text-red-500" width={16} height={16} fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                    {agreements?.map((element, index) => (
                                        <div className="flex items-center mt-4 text-start" key={element.id}>
                                            <div className="flex">
                                                <input
                                                    checked={agreementChecked[element.id]}
                                                    onChange={() => toggleAgreementCheck(element.id)}
                                                    id={`remember-me${index}`}
                                                    type="checkbox"
                                                    name="remember-me"
                                                    className="onedose-color shrink-0 border-gray-200 rounded text-blue-600 focus:ring-blue-500 dark:bg-gray-800 dark:border-gray-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
                                                />
                                            </div>
                                            <div className="ml-3">
                                                <label htmlFor={`remember-me${index}`} className="text-sm dark:text-white">
                                                    {element.isOptional == false ?
                                                        <b className="text-red-500 hs-tooltip-toggle hs-tooltip inline-block me-2">
                                                            *
                                                            <span
                                                                className="hs-tooltip-content hs-tooltip-shown:opacity-100 hs-tooltip-shown:visible opacity-0 transition-opacity inline-block absolute invisible z-10 py-1 px-2 bg-gray-900 text-xs font-medium text-white rounded shadow-sm dark:bg-slate-700"
                                                                role="tooltip"
                                                            >
                                                                Bu sözleşmeyi onaylamak zorundasınız.
                                                            </span>
                                                        </b>
                                                        : null}
                                                    <a
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault(); // Bu satır varsayılan davranışı engeller
                                                            // Burada modal açma işlevselliğinizi tetikleyin
                                                        }}
                                                        data-hs-overlay={`#hs-vertically-centered-scrollable-modal${index}`}
                                                        className="onedose-color"
                                                    >
                                                        {element.description}
                                                    </a>
                                                </label>
                                            </div>
                                        </div>
                                    ))}

                                    {agreements?.map((element, index) => {
                                        return (
                                            <div key={index} id={`hs-vertically-centered-scrollable-modal${index}`} className="hs-overlay hidden w-full h-full fixed top-0 left-0 z-[60] overflow-x-hidden overflow-y-auto">
                                                <div className="hs-overlay-open:mt-7 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-0 opacity-0 ease-out transition-all lg:max-w-4xl lg:w-full m-3 lg:mx-auto">
                                                    <div className="flex flex-col bg-white border shadow-sm rounded-xl dark:bg-gray-800 dark:border-gray-700 dark:shadow-slate-700/[.7]">
                                                        <div className="flex justify-between items-center py-3 px-4 border-b dark:border-gray-700">
                                                            <iframe
                                                                width="100%"
                                                                height="500vh"
                                                                src={element.contentUrl}
                                                                title="YouTube video player"
                                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                allowFullScreen
                                                            ></iframe>
                                                        </div>
                                                        <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t dark:border-gray-700">
                                                            <button
                                                                type="button"
                                                                className="hs-dropdown-toggle py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border font-medium bg-white text-gray-700 shadow-sm align-middle hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-[#09C35C] transition-all text-sm dark:bg-slate-900 dark:hover:bg-slate-800 dark:border-gray-700 dark:text-gray-400 dark:hover:text-white dark:focus:ring-offset-gray-800"
                                                                data-hs-overlay={`#hs-vertically-centered-scrollable-modal${index}`}
                                                            >
                                                                Vazgeç
                                                            </button>
                                                            <button
                                                                type='button'
                                                                data-hs-overlay={`#hs-vertically-centered-scrollable-modal${index}`}
                                                                onClick={() => toggleAgreementCheck(element.id)}
                                                                className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-[#09C35C] text-white hover:bg-[#079b49] focus:outline-none focus:ring-2 focus:ring-[#09C35C] focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800"
                                                            >
                                                                Okudum Onayladım
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                    {props.register.spinner ?
                                        <button type="button" style={{ backgroundColor: `#09C35C` }} className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800">
                                            <span className="animate-spin inline-block w-4 h-4 border-[3px] border-current border-t-transparent text-white rounded-full" role="status" aria-label="loading"></span>
                                            İşlem devam ediyor
                                        </button>
                                        :
                                        <button type="submit" style={{ backgroundColor: `#09C35C` }} className="py-3 px-4 inline-flex justify-center items-center gap-2 rounded-md border border-transparent font-semibold bg-blue-500 text-white hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all text-sm dark:focus:ring-offset-gray-800">Devam et</button>
                                    }
                                </div>
                            </form>
                            {/* End Form */}
                        </div>
                    </div>
                </div>
            </main>
        </div>
    )
}

const mapStateToProps = (state) => {
    return state;
};
const mapDispatchToProps = {
};
export default connect(mapStateToProps, mapDispatchToProps)(Register);